const TEST_SESSION_STATUS = {
  completed: 'completed',
  processing: 'processing',
  processed: 'processed',
  pending: 'pending',
  error: 'error',
  upload_error: 'upload_error',
  transcribe_error: 'transcribe_error',
};

export const TEST_SESSION_BOOKING_STATUS = {
  confirmed: {
    value: 'confirmed',
    label: 'Confirmed',
  },
  didNotShow: {
    value: 'did_not_show',
    label: 'Participant did not show',
  },
  researcherDidNotSHow: {
    value: 'researcher_did_not_show',
    label: 'Researcher did not show',
  },
  interviewCompleted: {
    value: 'interview_completed',
    label: 'Interview completed',
  },
  rescheduling: {
    value: 'rescheduling',
    label: 'Rescheduling',
  },
};

export default TEST_SESSION_STATUS;
